export default __webpack_public_path__ + "static/media/default-avatar.67d6f19e.svg";